import { indentWithTab, standardKeymap } from '@codemirror/commands';
import { EditorView, keymap } from '@codemirror/view';
import React, { useEffect, useRef } from 'react';
import { EditorState } from '@codemirror/state';
import { json } from '@codemirror/lang-json';
import { basicSetup } from 'codemirror';

const basicExtensions = [basicSetup, keymap.of([standardKeymap, indentWithTab]), json(), EditorState.tabSize.of(2)];

const JsonEditor = ({ jsonData, setJsonData, isEditable = true }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current === null) return;

    const state = EditorState.create({
      doc: jsonData,
      extensions: [
        ...basicExtensions,
        EditorView.updateListener.of(({ view }) => {
          let tempValue = view.state.toJSON();
          setJsonData(tempValue.doc);
        }),
        EditorView.editable.of(isEditable),
      ],
    });

    const view = new EditorView({
      state,
      parent: editorRef.current,
    });

    return () => {
      view.destroy();
    };
  }, [editorRef.current, jsonData, isEditable]);

  return <div ref={editorRef} className="jsonEditor"></div>;
};

export default JsonEditor;
